import {FormApp} from "./FormApp";
require("regenerator-runtime/runtime");


let ReactDOM = require("react-dom");
import * as React from "react";
import {WpAjaxPost} from "shared/core/ajax/WPAjaxPost";
WpAjaxPost.SetGlobalVar(rnFormVar);
import './Bootstrap.css'
ReactDOM.render(<FormApp/>,document.getElementById('App'))